import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';
import { DatabaseCertificationFragmentGql } from './DatabaseCertificationFragmentGql';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

export const DatabaseFragmentGql: DocumentNode = gql`
fragment DatabaseFragment on Database {
  id
  luid
  vizportalId
  name
  description
  isGrouped
  isEmbedded
  ...DatabaseCertificationFragment
  contact {
    ...TableauUserFragment
  }
  connectionType
  dataQualityWarnings {
    ...DataQualityWarningFragment
  }
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
${DatabaseCertificationFragmentGql}
${DataQualityWarningFragmentGql}
${TableauUserFragmentGql}
`;
